<template>
    <div class="l-inline l-center-v l-gap-1">
        <b class="no-breaks">{{ field.label }}</b>

        <input
            v-if="field.type === 'boolean'"
            type="checkbox"
            :checked="field.value"
            class="no-pointer-events"
        />

        <a
            v-else-if="field.format === 'uri'"
            :href="field.value"
            target="_blank"
            class="t-truncated t-underline"
        >
            {{ field.value }}
        </a>

        <span v-else>{{ field.value }}</span>
    </div>
</template>

<script>
export default {
    name: 'CustomerField',
    props: {
        field: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.no-breaks {
    white-space: nowrap;
}

.no-pointer-events {
    pointer-events: none;
}
</style>
